import { useEffect, useState } from "react";
import sal from "sal.js";
import { Provider } from "react-redux";
import BlogData from "../../data/blog/blog.json";
import PageHead from "../Head";
import Store from "@/redux/store";
import Context from "@/context/Context";
import MobileMenu from "@/components/Header/MobileMenu";
import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import Cart from "@/components/Header/Offcanvas/Cart";
import Banner from "@/components/Common/Banner";
import BlogGrid from "@/components/Blogs/BlogGrid";
import BackToTop from "../backToTop";
import Separator from "@/components/Common/Separator";
import FooterOne from "@/components/Footer/Footer-One";
import { BaseApiService } from "@/utils/BaseApiService";

const BlogGridLayout = () => {

  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    sal({
      threshold: 0.01,
      once: true,
    });
  }, []);

  const fetchArticles = async () => {
    let searchParameters = { searchTerm: "", offset: 0, limit: 0, type: 'PROFESSIONAL_JOURNAL' };
    try {
      const response = await new BaseApiService("/articles").getRequestWithJsonResponse(
        searchParameters
      );
      console.log("Articles Response:", response);
      if (response && response.records) {
        setBlogs(response.records);
        console.log("Articles set:", response.records); // Log the state update
      } else {
        console.error("Unexpected response structure:", response);
      }
    } catch (error) {
      console.error("fetchEvents:fetchDataFromServer>>>>", error);
    }
  };

  useEffect(() => {
    fetchArticles();
  }, [setBlogs]);


  return (
    <>
      <PageHead title="Blog Grid - Online Courses & Education NEXTJS14 Template" />
      <Provider store={Store}>
        <Context>
          <MobileMenu />
          <HeaderStyleTen headerSticky="rbt-sticky" headerType="" />
          <Cart />

          <Banner col="col-lg-12" text="All Blog" getBlog={blogs} />
          <div className="rbt-blog-area rbt-section-overlayping-top rbt-section-gapBottom">
            <div className="container">
              <BlogGrid fetchedBlogs={blogs} isPagination={true} top={true} start={0} end={6} />
            </div>
          </div>

          <BackToTop />
          <Separator />
          <FooterOne bgColor="bg-color-darker" />
        </Context>
      </Provider>
    </>
  );
};

export default BlogGridLayout;
